import m from './1.0.0/index.vue'

export default m;
